import React, { useEffect, useState } from 'react'
import config from 'config';
import NoticeboardAPICall from "NoticeboardAPICall";

import { Link } from 'react-router-dom';
import './ManageCategory.css';
import CategoryList from './CategoryList';
import UserList from './UserList';
import RouteMenu from 'NOTICEBOARD/CommonResources/RoutingMenu/RouteMenu';

function ManageCategory() {
    const [currentTab, setCurrentTab] = useState(0);
    return (
        <>
            <div className="sideMenu" style={ { padding: 0 } }>
                <RouteMenu activeScreen="grantaccess" />
            </div>
            <div className='noticeComponents' style={ { marginBottom: "5rem" } }>
                <div 
                    className='row col-md-12'
                    style={{
                        position: 'sticky',
                        top: '50px',
                        backgroundColor: '#fff',
                        zIndex: 1,
                    }}  
                >
                    <div className='col-md-12' style={ { padding: 0 } }>
                        <ul className='nav'>
                            <li className={ !currentTab ? "tab selectedtab" : "tab" } onClick={ () => setCurrentTab(0) }>
                                <a className='nav-link '>Category Management</a>
                            </li>
                            <li className={ currentTab ? "tab selectedtab" : "tab" } onClick={ () => setCurrentTab(1) }>
                                <a className='nav-link'>User Management</a>
                            </li>
                        </ul>
                    </div>
                </div>
                {/* TAB FOR CATEGORY COMPONENT  */ }
                {
                    currentTab == 0 && <CategoryList />
                }
                {/* TAB FOR  USER COMPONENT */ }
                {
                    currentTab == 1 && <UserList />
                }
            </div>
        </>

    )
}

export default ManageCategory
